(function(){
  function cleanText(s){
    return s
      .replace(/Estime\s*&\s*sens/g,'Estime&Sens')
      .replace(/Estime\s*&amp;\s*sens/g,'Estime&Sens')
      .replace(/\bseance\b/gi,function(m){return m[0]===m[0].toUpperCase()?'Séance':'séance';})
      .replace(/\bEndermologie\b/g,'endermologie')
      .replace(/\bepilation\b/gi,function(m){return m[0]===m[0].toUpperCase()?'Épilation':'épilation';})
      .replace(/\(\s+/g,'(').replace(/\s+\)/g,')');
  }
  function walk(root){
    var w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT); var n, nodes=[];
    while(n=w.nextNode()) nodes.push(n);
    nodes.forEach(function(x){ if(x.parentElement && !/SCRIPT|STYLE|TEXTAREA/.test(x.parentElement.tagName)){ var v=cleanText(x.nodeValue); if(v!==x.nodeValue)x.nodeValue=v; }});
  }
  function sentenceFix(el){
    var html=el.innerHTML;
    html=html.replace(/(^|>)(\s*)(un soin)/gi,function(_,a,b,c){return a+b+'Un soin';});
    html=html.replace(/(^|[.!?]\s+|<br\s*\/?>(\s*))(grâce)/gi,function(m,a,b,c){return a+(b||'')+'Grâce';});
    html=html.replace(/(^|[.!?]\s+|<br\s*\/?>(\s*))(le teint)/gi,function(m,a,b,c){return a+(b||'')+'Le teint';});
    html=html.replace(/verii?table/gi,'véritable');
    html=html.replace(/Estime\s*&(?:amp;)?\s*sens/gi,'Estime&Sens');
    // requested readable sentence break before Grâce
    html=html.replace(/([.!?])\s+Grâce/g,'$1<br>Grâce');
    el.innerHTML=html;
    // remove exact duplicated adjacent paragraphs
    var ps=[].slice.call(el.querySelectorAll('p'));
    ps.forEach(function(p,i){if(i&&p.textContent.trim()===ps[i-1].textContent.trim())p.remove();});
  }
  function apply(){
    walk(document.body);
    document.querySelectorAll('a').forEach(function(a){
      if(a.textContent.trim()==='A propos') a.textContent='À propos';
      if(a.textContent.trim()==='Estime&sens') a.textContent='Estime&Sens';
    });
    document.querySelectorAll('.ba-service-description,.product-information__description,.rte').forEach(sentenceFix);
    // Product-specific display corrections requested
    var title=(document.querySelector('h1')||{}).textContent||'';
    if(/massage.*duo.*75/i.test(title)){
      document.querySelectorAll('.price,price-component,.product-price,[class*=price]').forEach(function(e){ if(/€|EUR/.test(e.textContent)) e.textContent='150,00 €'; });
      document.querySelectorAll('*').forEach(function(e){if(e.children.length===0 && /épuisé|indisponible|sold out|unavailable/i.test(e.textContent)) e.textContent='Disponible';});
    }
    // hide 4-hands massage from merchandising surfaces
    document.querySelectorAll('a,h3,h2').forEach(function(e){if(/massage.{0,10}4 mains/i.test(e.textContent)){var card=e.closest('li,.card,.product-card,.ba-service-card'); if(card)card.style.display='none';}});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',apply);else apply();
})();
